import { useQuery } from '@tanstack/react-query';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { api } from '../api';
import { can } from '../auth/me';
import { useMe } from '../auth/useMe';
import { EVENTS_KEY, EVENTS_RESOURCE, formatEventRange, type EventView } from '../events/labels';
import type { WizardLanding } from '../planning/NewEventWizard';
import { PacklistEditor } from './PacklistEditor';
import { packlistKey, type PacklistView } from './types';
import './packlists.css';

/**
 * "Sprzętówka" on its own screen (owner remark 19; links from the bell, the loading screens). The same editor is the
 * event card's tab "Sprzętówka" (owner 2026-10-21 23:31). "Przejdź do kosztorysu" opens the card on its quote.
 */
export function PacklistEditorPage() {
  const { eventId = '' } = useParams();
  const { me } = useMe();
  const navigate = useNavigate();
  const list = useQuery({ queryKey: packlistKey(eventId), queryFn: () => api<PacklistView>(`/api/packlists/${eventId}`) });
  const event = useQuery({
    queryKey: [...EVENTS_KEY, 'one', eventId],
    enabled: !!me && can(me, EVENTS_RESOURCE, 'view'),
    retry: false,
    queryFn: () => api<EventView>(`/api/events/${eventId}`),
  });
  if (!me) return null;
  const title = list.data?.event.name || event.data?.name || 'Sprzętówka';
  const e = event.data;
  const dates = e?.startsAt && e.endsAt ? formatEventRange(e.startsAt, e.endsAt) : '';

  return (
    <section className="page wide pl-editor" aria-label="Edytor sprzętówki">
      <p className="crumb">
        <Link to={`/wydarzenia?wydarzenie=${eventId}`}>← Wróć do wydarzenia</Link>
      </p>
      <PacklistEditor
        eventId={eventId}
        onGoToQuote={(notice) => navigate(`/wydarzenia?wydarzenie=${eventId}&zakladka=kosztorys`, { state: { notice: notice.text } satisfies WizardLanding })}
        title={
          <div className="pl-title">
            <h1>{title}</h1>
            <p className="pl-dates">
              {dates && <span>{dates}</span>}
              <span>Sprzętówka</span>
            </p>
          </div>
        }
      />
    </section>
  );
}
